{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "file:///InterestsAcitivitesGoals.json",
  "title": "InterestsAcitivitesGoals",
  "type": "object",
  "properties": {
    "academicInterestsList": {
      "type": "array",
      "contains": {
        "type": "string"
      },
      "minContains": 1,
      "maxContains": 10
    },
    "personalInterestsList": {
      "type": "array",
      "contains": {
        "type": "string"
      },
      "minContains": 1
    },
    "activityList": {
      "type": "array",
      "contains": {
        "type": "string"
      },
      "minContains": 1
    },
    "gradSchoolPlans": {
      "type": "string",
      "minLength": 1
    },
    "gradProgramsAbroadInterest": {
      "type": "string",
      "minLength": 1
    },
    "futureGoals": {
      "type": "string",
      "minLength": 1
    },
    "knowsHipsValue": {
      "type": "string",
      "minLength": 1
    },
    "experiences": {
      "type": "array",
      "items": {
        "$ref": "file:///Experiences.json"
      }
    }
  }
}